import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getOrdersList() {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/crm/get-orders-list`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getOrdersList,
};
